import { Client } from "./client";
import { Config } from "./types";

export function createClient(config: Config) {
  return new Client(config);
}

export async function createMicrophoneAudioTrack(sampleRate: number, config?: Config): Promise<MediaStream> {
  const audioConstraints = {
    sampleRate: sampleRate,
    echoCancellation: true,
    noiseSuppression: true,
    channelCount: 1,
    autoGainControl: true,
    latency: 0,
    ...(config?.audioSource?.constraints || {}),
  };

  if (config?.audioSource?.deviceId) {
    audioConstraints.deviceId = config.audioSource.deviceId;
  }

  return (navigator.mediaDevices as any).getUserMedia({
    audio: audioConstraints,
  });
}